import { IResponse, Model, ObjectsFactory } from '@/data'
import { GET_TOKEN_DETAIL_ENDPOINT, GET_TOKEN_ENDPOINT } from '@/data/endpoint'
import { IListTokens, ITokenCap } from '@/types'

export class Token extends Model {
  static config = { endpoint: GET_TOKEN_ENDPOINT }

  static objects = ObjectsFactory.factory<ITokenCap>(Token.config)

  static async getToken(symbol: string) {
    return await this.service.get<IResponse<ITokenCap>>({
      url: `${GET_TOKEN_DETAIL_ENDPOINT}/${symbol}`,
    })
  }

  static async listToken(whitelistAddresses: string[]) {
    const queryString = whitelistAddresses.length > 0 ? `?address=${whitelistAddresses.join(',')}` : ''
    return await this.service.get<IResponse<IListTokens>>({
      url: `${GET_TOKEN_ENDPOINT}${queryString}`,
    })
  }
}

Token.init(Token.config)
